import { EnvironmentType } from '../enum/environment.type';
import { IEncryptionDriver } from './encryption-driver.interface';
import { IRequestDriver } from './request-driver.interface';

export interface IFgApiInitializationOptions {
  environment: EnvironmentType;
  requestDriver: IRequestDriver;
  encryptionDriver: IEncryptionDriver;
  timeout: number;
}